import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useLayout } from '@/app/store/layout.store';

import { PlatformShell } from '@/shared/ui/templates/PlatformShell';
import { PlatformSidebar } from '@/widgets/PlatformSidebar';
import { Topbar } from '@/widgets/Topbar';

export function PlatformLayout() {
  const { sidebarOpen, setSidebarOpen } = useLayout();
  const { pathname } = useLocation();
  useEffect(() => setSidebarOpen(false), [pathname, setSidebarOpen]);
  return <PlatformShell sidebarOpen={sidebarOpen} onSidebarClose={() => setSidebarOpen(false)} sidebar={<PlatformSidebar />} topbar={<Topbar platform />} content={<Outlet />} />;
}
